import { Component, Input, OnInit } from '@angular/core';

import { Product } from '@features/opportunities/models/product-selection/product-selection.model';

@Component({
  selector: 'app-product-selection-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductSelectionProductComponent implements OnInit {
  // inputs
  @Input()
  product!: Product;

  @Input()
  isPackaged: boolean = false;

  // localise
  public collapse: boolean = true;

  ngOnInit(): void { }

  public get isCollapsible(): boolean {
    return this.isPackaged;
  }

  public get isCollapsed(): boolean {
    return this.isCollapsible && this.collapse;
  }

  public onClick(): void {
    if (!this.isCollapsible) {
      return; // guard
    }

    this.collapse = !this.collapse;
  }

  public get isInvalid(): boolean {
    return !this.product.isProductValid;
  }

  ceiling = Math.ceil;
}
